import { Box, Grid, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import React from 'react';

import rasCardImage from '../../assets/images/ras-card-image.png';
import rasCardImageMobile from '../../assets/images/ras-card-image-mobile.png';
import { rasCardContent } from './Content';
import { rasLandingPage } from './Links';




const RasBanner = () => {
    const theme = useTheme();
    const smallBreakpoint = useMediaQuery(theme.breakpoints.down('sm'))
    return (
        <Box className='beacon-theme-modern-outlook'>
            <Box id='ras-cta-hero-card-container' className='b-container' sx={{ inlineSize: 'unset !important'}}>
                <Grid container sx={{padding: '60px 0 70px 0'}}>
                    <Grid item size={{ xs: 12, md: 3 }}>
                        <Box 
                        sx={{
                                padding:{ xs: 0, sm: '0 48px 16px 0' },
                                height: '100%',
                        }}
                        id='ras-cta-hero-img-container'>
                            <img
                                style={{
                                    height: '100%',
                                    width: '100%'
                                }}
                                src={smallBreakpoint ? rasCardImageMobile : rasCardImage}
                                alt='ras-hero'
                                id='ras-hero'
                            />
                        </Box>
                    </Grid>
                    <Grid item size={{ xs: 12, md: 9 }}>
                        <Box id='ras-cta-hero-content-container'>
                            <Box id='ras-cta-hero-title' className='b-typography-serif--headline-loose--300'>
                                {rasCardContent.title}
                            </Box>
                            <Box id='ras-cta-hero-content' className='b-typography-sans-serif--body--200' pb='24px'>
                                {rasCardContent.content}
                            </Box>
                            <Box id='ras-cta-hero-button-container'>
                                <Button 
                                    fullWidth={smallBreakpoint}
                                    sx={{
                                        boxShadow: 'none',
                                        background: '#FFFFFF',
                                        backgroundColor: '#FFFFFF',
                                        border: '1px solid #086EA1',
                                        padding: '8px 16px',
                                        whiteSpace: 'nowrap',
                                        '&:hover': {
                                            backgroundColor: '#086EA1',
                                            color: '#FFFFFF',
                                            border: '1px solid #086EA1'
                                        },
                                        fontSize: '16px',
                                        maxHeight: '40px',
                                        fontWeight: 'bold',
                                        color: '#086EA1',
                                        textTransform: 'capitalize'
                                    }}
                                    href={rasLandingPage}
                                    data-metrics-location='CTA'
                                    id='ras-cta-hero-button'
                                    target='_blank'
                                >
                                        Explore Retirement Advisory Service
                                </Button>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    )
};

export default RasBanner;